var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.options.hasAction && 'actionable',on:{"click":_vm.handleAction}},[_c('v-img',{attrs:{"contain":"","lazy-src":require(`@/assets/apple-style/${_vm.options.img}`),"src":require(`@/assets/apple-style/${_vm.options.img}`)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }